import React from 'react';

export function usePagination(items, pageSize, page) {
  const totalPages  = Math.max(1, Math.ceil(items.length / pageSize));
  const safePage    = Math.min(Math.max(1, page), totalPages);
  const pageItems   = items.slice((safePage - 1) * pageSize, safePage * pageSize);
  return { pageItems, totalPages, safePage };
}

export default function Paginator({ total, pageSize, setPageSize, page, setPage, sizes = [5, 25, 50, 100] }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage   = Math.min(Math.max(1, page), totalPages);
  const from       = total === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const to         = Math.min(safePage * pageSize, total);

  const pageNums = Array.from({ length: totalPages }, (_, i) => i + 1)
    .filter((p) => p === 1 || p === totalPages || Math.abs(p - safePage) <= 1)
    .reduce((acc, p, idx, arr) => {
      if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...');
      acc.push(p);
      return acc;
    }, []);

  const btnBase = 'px-2 py-1 rounded hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed text-sm';

  return (
    <div className="px-4 py-3 border-t border-gray-100 flex items-center justify-between flex-wrap gap-2 text-sm text-gray-500">
      {/* Left: info + page size */}
      <div className="flex items-center gap-2">
        <span>แสดง {from}–{to} จาก {total} รายการ</span>
        <span className="text-gray-300">|</span>
        <span>แสดง</span>
        <select
          value={pageSize}
          onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
          className="border border-gray-200 rounded-lg px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white"
        >
          {sizes.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
        <span>รายการ/หน้า</span>
      </div>

      {/* Right: page buttons */}
      <div className="flex items-center gap-1">
        <button onClick={() => setPage(1)} disabled={safePage === 1} className={btnBase} title="หน้าแรก">«</button>
        <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={safePage === 1} className={btnBase}>‹</button>
        {pageNums.map((p, i) =>
          p === '...' ? (
            <span key={`e${i}`} className="px-2 text-gray-300">…</span>
          ) : (
            <button
              key={p}
              onClick={() => setPage(p)}
              className={`w-8 h-8 rounded text-xs font-medium transition-colors
                ${p === safePage ? 'bg-primary text-white' : 'hover:bg-gray-100'}`}
            >
              {p}
            </button>
          )
        )}
        <button onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={safePage === totalPages} className={btnBase}>›</button>
        <button onClick={() => setPage(totalPages)} disabled={safePage === totalPages} className={btnBase} title="หน้าสุดท้าย">»</button>
      </div>
    </div>
  );
}
